import { Controller } from '@hotwired/stimulus';
import { Tooltip } from 'bootstrap';

// 入力欄にフォーカスしている間だけ、隣のヒント要素の BS5 Tooltip を表示する。
// 旧 signups の inline jQuery
//   $(document).on('focus', '#user_email', () => $('#email-tip').tooltip('show'))
// を Stimulus 化したもの。tip 要素(this.element)に controller を付け、
// data-field-tooltip-field-value に対象入力欄の id を渡す。
export default class extends Controller {
  static values = { field: String };

  connect() {
    this.tooltip = Tooltip.getOrCreateInstance(this.element, { trigger: 'manual' });
    this.field = document.getElementById(this.fieldValue);
    if (!this.field) return;

    this.onFocus = () => this.tooltip.show();
    this.onBlur = () => this.tooltip.hide();
    this.field.addEventListener('focus', this.onFocus);
    this.field.addEventListener('blur', this.onBlur);
  }

  disconnect() {
    if (this.field) {
      this.field.removeEventListener('focus', this.onFocus);
      this.field.removeEventListener('blur', this.onBlur);
    }
    if (this.tooltip) this.tooltip.dispose();
  }
}
